import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import "../css/Header.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSchool, faCaretDown, faBars, faGraduationCap, faPersonChalkboard, faMobileScreenButton, faBinoculars, faUniversity } from '@fortawesome/free-solid-svg-icons';

import 'bootstrap/dist/css/bootstrap.css';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

const Header = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const location = useLocation();
  const isHome = location.pathname === '/inicio' || location.pathname === '/';

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navRef = useRef();

  const handleToggleClick = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setIsCollapsed(true);
    }
  };

  const handleDropdownClick = (isOpen) => {
    setIsDropdownOpen(isOpen);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Navbar style={{display:"flex"}} expand="lg" id='header' ref={navRef} expanded={!isCollapsed}>
      <Navbar.Brand href="inicio">
        <img src={'assets/images/logo/colegio-lider-2.png'} alt="Líder" id='logo'/>
      </Navbar.Brand>
      <Nav style={{flexGrow:1, justifyContent:"center"}} className={`${isMobile ? 'hidden' : 'show'}`}>
        <Nav.Link target='_blank' style={{color:"white"}} href="https://cpa.escolarmanageronline.com.br/colegiolider">
            <FontAwesomeIcon icon={faGraduationCap} /> <span>PORTAL DO ALUNO</span>
          </Nav.Link>
          <Nav.Link target='_blank' style={{color:"white"}} href="https://professor.escolarmanageronline.com.br/colegiolider/Login">
            <FontAwesomeIcon icon={faPersonChalkboard} /> <span>PORTAL DO PROFESSOR</span>
          </Nav.Link>
      </Nav>
      <Navbar.Toggle aria-controls="basic-navbar-nav" id='toggle' onClick={handleToggleClick}>
        <span id="bars"><FontAwesomeIcon icon={faBars} /></span>
      </Navbar.Toggle>
      <Navbar.Collapse id="basic-navbar-nav" style={{flexBasis:"fit-content", flexGrow: 0}} className={`justify-content-end ${isCollapsed ? 'hidden' : 'show'}`}>
        <Nav>
          <Nav.Link href="inicio" id='white'>
            <FontAwesomeIcon icon={faHome} /> <span id="underline">INÍCIO</span>
          </Nav.Link>
          <Nav.Link href="institucional" id='white'>
            <FontAwesomeIcon icon={faUniversity} /> <span id="underline">INSTITUCIONAL</span>
          </Nav.Link>
          <NavDropdown 
            title={<span><FontAwesomeIcon icon={faSchool} /> <span id="underline">ENSINO E EDUCAÇÃO</span>
                <FontAwesomeIcon 
                  icon={faCaretDown} 
                  className={isDropdownOpen ? 'rotate180' : ''}
                  id='icone' 
                />
              </span>
            }  
            id="white"
            onToggle={handleDropdownClick}
          >
            <NavDropdown.Item href="ensino-fundamental-1" id='black'>
              <span id="underline">Ensino Fundamental 1</span>
            </NavDropdown.Item>
            <NavDropdown.Item href="ensino-fundamental-2" id='black'>
              <span id="underline">Ensino Fundamental 2</span>
            </NavDropdown.Item>
            <NavDropdown.Item href="ensino-medio">Ensino Médio</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="nossa-equipe">
              <span id="underline">Nossa Equipe</span>
            </NavDropdown.Item>
            <NavDropdown.Item href="materiais">
              <span id="underline">Lista de Materiais</span>
            </NavDropdown.Item>
          </NavDropdown>
          {!isCollapsed && (
            <>
              <Nav.Link target='_blank' style={{color:"black", width: "100%"}} href="https://cpa.escolarmanageronline.com.br/colegiolider">
                <FontAwesomeIcon icon={faGraduationCap} /> <span id="underline">PORTAL DO ALUNO</span>
              </Nav.Link>
              <Nav.Link target='_blank' style={{color:"black"}} href="https://professor.escolarmanageronline.com.br/colegiolider/Login">
                <FontAwesomeIcon icon={faPersonChalkboard} /> <span id="underline">PORTAL DO PROFESSOR</span>
              </Nav.Link>
            </>
          )}
          <Nav.Link style={{color:`${isCollapsed ? 'white' : 'black'}`, paddingLeft:`${isCollapsed ? 0 : "5px"}` }} href="tour360">
            <FontAwesomeIcon icon={faBinoculars} /> <span id="underline">TOUR 360</span>
          </Nav.Link>
          <Nav.Link target='_blank' style={{color:`${isCollapsed ? 'white' : 'black'}`, paddingLeft:`${isCollapsed ? 0 : "5px"}` }} href="https://xn--colgioldergo-deb4d.my.canva.site/baixe-o-app-do-col-gio-l-der">
            <FontAwesomeIcon icon={faMobileScreenButton} /> <span id="underline">DOWNLOAD APP</span>
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
